export default __webpack_public_path__ + "static/media/chronic-telogen-effluviump.9de2ed86.pdf";